import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../ThemeContext';
import logoMark from '../assets/ufeus-logo-mark.png';

const NAVBAR_HEIGHT = 80;

function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  return (
    <button
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className="w-9 h-9 flex items-center justify-center rounded-ctl border transition"
      style={{ borderColor: 'var(--border-medium)', color: 'var(--accent)' }}
    >
      {theme === 'dark' ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="5" />
          <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
        </svg>
      )}
    </button>
  );
}

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname !== '/') {
      window.location.href = '/#' + id;
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.pageYOffset - NAVBAR_HEIGHT;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const scrollToHero = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname !== '/') {
      window.location.href = '/#hero-section';
      return;
    }
    const hero = document.getElementById('hero-section');
    if (hero) {
      const y = hero.getBoundingClientRect().top + window.pageYOffset - NAVBAR_HEIGHT;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const goToTrainings = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    if (location.pathname !== '/trainings') {
      navigate('/trainings');
      setTimeout(() => {
        const el = document.getElementById('trainings-hero');
        if (el) {
          const y = el.getBoundingClientRect().top + window.pageYOffset - NAVBAR_HEIGHT;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }, 100);
    } else {
      const el = document.getElementById('trainings-hero');
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - NAVBAR_HEIGHT;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }
  };

  const navLinks = [
    { label: 'Build', id: 'build', onClick: (e) => scrollToSection(e, 'build') },
    { label: 'Founders', id: 'founders', onClick: (e) => scrollToSection(e, 'founders') },
    { label: 'Mission', id: 'mission', onClick: (e) => scrollToSection(e, 'mission') },
    { label: 'Train', id: 'train', onClick: goToTrainings },
    { label: 'Careers', id: 'careers', onClick: (e) => scrollToSection(e, 'careers') },
  ];

  return (
    <nav
      className="fixed top-0 left-0 w-full z-50 backdrop-blur-md border-b flex items-center justify-between px-6 md:px-10 py-2"
      style={{ backgroundColor: 'color-mix(in srgb, var(--bg) 85%, transparent)', borderColor: 'var(--border-c)' }}
    >
      <button
        onClick={scrollToHero}
        className="focus:outline-none flex items-center"
        style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
        aria-label="Scroll to top / hero"
      >
        <img src={logoMark} alt="Ufeus Consultancy Services" className="h-11 md:h-12" />
      </button>

      <div className="hidden md:flex items-center gap-8 t-sm" style={{ color: 'var(--text-secondary)' }}>
        {navLinks.map((l) => (
          <a
            key={l.id}
            href={`#${l.id}`}
            className="transition hover:text-[var(--accent)]"
            onClick={l.onClick}
          >
            {l.label}
          </a>
        ))}
      </div>

      <div className="flex items-center gap-3">
        <div className="hidden md:block">
          <ThemeToggle />
        </div>
        <div className="md:hidden flex items-center gap-3">
          <ThemeToggle />
          <button
            className="focus:outline-none"
            style={{ color: 'var(--accent)' }}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <svg width="28" height="28" fill="none" viewBox="0 0 24 24">
              <rect y="5" width="24" height="2" rx="1" fill="currentColor" />
              <rect y="11" width="24" height="2" rx="1" fill="currentColor" />
              <rect y="17" width="24" height="2" rx="1" fill="currentColor" />
            </svg>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div
          className="absolute top-16 right-6 rounded-card shadow-lg flex flex-col gap-4 p-6 t-sm animate-fade-in z-50 min-w-[180px] card"
          style={{ color: 'var(--text-secondary)' }}
        >
          {navLinks.map((l) => (
            <a key={l.id} href={`#${l.id}`} className="hover:text-[var(--accent)] transition" onClick={l.onClick}>
              {l.label}
            </a>
          ))}
        </div>
      )}
      <style>{`
        @keyframes fade-in { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: none; } }
        .animate-fade-in { animation: fade-in 0.2s ease; }
      `}</style>
    </nav>
  );
}
